import React from 'react';
import { motion } from "framer-motion"

export default function CareersPage() {
  const openRoles = [
    { title: 'Frontend Developer', type: 'Full-time', location: 'Remote' },
    { title: 'UI/UX Designer', type: 'Internship', location: 'Remote' },
    { title: 'Content & SEO Strategist', type: 'Freelance', location: 'India' },
  ];

  return (
    <div className="bg-gray-50 py-12 px-4 md:px-16">
      <motion.section
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="p-6 md:p-16 text-center"
      >
        {/* Hero */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Work With Us
          </h1>
          <p className="text-gray-600 max-w-96 mx-auto">
            Join a mission-driven team helping marketers build smarter, faster, and with more clarity using AI.
          </p>
        </div>
      </motion.section>

      <motion.section
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.2 }}
        className="py-12 px-4 md:px-16"
      >
        {/* Why Join */}
        <section className="mb-16">
          <h2 className="text-2xl font-semibold mb-4">Why Join AdMentorAI?</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h3 className="text-lg font-medium mb-2">Make Real Impact</h3>
              <p className="text-gray-600">We're not just optimizing ads — we're empowering businesses worldwide to grow meaningfully.</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h3 className="text-lg font-medium mb-2">Own Your Craft</h3>
              <p className="text-gray-600">You’ll have freedom and responsibility to drive your own projects.</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h3 className="text-lg font-medium mb-2">Remote Culture</h3>
              <p className="text-gray-600">We’re remote-first with async-friendly workflows and flexible hours.</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md">
              <h3 className="text-lg font-medium mb-2">Learn & Grow</h3>
              <p className="text-gray-600">We provide learning budgets and mentorship to grow your skills.</p>
            </div>
          </div>
        </section>

        {/* Open Roles */}
        <section className="mb-16">
          <h2 className="text-2xl font-semibold mb-4">Open Positions</h2>
          <div className="space-y-4">
            {openRoles.map((role, index) => (
              <div key={index} className="flex justify-between bg-white p-4 rounded shadow-md">
                <div>
                  <h3 className="font-medium text-lg">{role.title}</h3>
                  <p className="text-sm text-gray-500">{role.type} | {role.location}</p>
                </div>
                <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
                  Apply
                </button>
              </div>
            ))}
            {openRoles.length === 0 && (
              <p className="text-gray-600">No open roles right now — but we’d love to hear from you!</p>
            )}
          </div>
        </section>

        {/* Culture & Values */}
        <section className="mb-16">
          <h2 className="text-2xl font-semibold mb-4">Our Values</h2>
          <ul className="space-y-2 text-gray-700 list-disc pl-6">
            <li>We value builders over talkers.</li>
            <li>We are kind, curious, and brutally honest.</li>
            <li>We take ownership and move with urgency.</li>
            <li>We learn fast and optimize for clarity.</li>
          </ul>
        </section>

        {/* CTA */}
        <section className="text-center">
          <h2 className="text-2xl font-semibold mb-4">Don’t see your role listed?</h2>
          <p className="text-gray-600 mb-4">We’re always excited to meet passionate people. Send us an email with your portfolio or resume!</p>
          <a
            href="mailto:careers@admentorai.com"
            className="inline-block bg-blue-600 text-white px-6 py-3 rounded font-medium hover:bg-blue-700 transition"
          >
            Reach Out
          </a>
        </section>
      </motion.section>
    </div>
  );
}
